import React, { useState, useEffect } from "react";
import UploadImage from "../../components/common/UploadImage/UplaodImage";
import { FaArrowLeftLong } from "react-icons/fa6";
import Swal from "sweetalert2";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormInput from "../../components/common/FormInput/FormInput";
import { getGalleryById, GalleryUpdate } from "../../api/service/gallery.service";
import "./Gallery.css";
import Button from "../../components/common/Button/Button";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../components/common/ToastNotification/ToastNotification";

const UpdateGallery = ({ setLoading }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [existingImage, setExistingImage] = useState("");

  useEffect(() => {
    const fetchGalleryData = async () => {
      if (!id) return navigate("/gallery");

      try {
        setLoading(true);
        const res = await getGalleryById(id);
        const data = res.data ?? res;
        console.log(data,"update gallery....")
        setTitle(data.title || "");
        setCategory(data.category || "");
        setDescription(data.description || "");
        setExistingImage(data.image?.url || "");
      } catch (err) {
        showToast.error("Failed to fetch gallery data");
        navigate("/gallery");
      } finally {
        setLoading(false);
      }
    };

    fetchGalleryData();
  }, [id, navigate, setLoading]);

  const handleSubmit = async () => {
    if (!title || !category) {
      Swal.fire("Error", "Title and category are required", "error");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("gallery_id", id);
      formData.append("title", title);
      formData.append("category", category);
      formData.append("description", description);

      if (selectedImage instanceof File) {
        formData.append("image", selectedImage);
      }

      await GalleryUpdate(formData);

      Swal.fire({
        title: "Success",
        text: "Gallery updated successfully",
        icon: "success",
        confirmButtonColor: "#C39B22",
      }).then(() => navigate("/gallery"));
    } catch (error) {
      showToast.error(
        error.response?.data?.message || "Failed to update gallery"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="d-flex gap-2 align-items-center mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/gallery")}
        />
        <h3 className="management-tile mb-0 ml-2">Update Gallery</h3>
      </div>

      <Row className="galleryform-container">
        <Col md={6} className="mb-3">
          <FormInput
            placeholder="Enter gallery title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Col>

        <Col md={6} className="mb-3">
          <FormInput
            placeholder="Enter gallery category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
        </Col>

        <Col xs={12} className="mb-3">
          <FormInput
            type="textarea"
            rows={4}
            placeholder="Enter gallery description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Col>

        <Col xs={12} className="mb-3">
          <UploadImage
            multiple={false}
            existingImages={existingImage}
            onFileSelect={(file) => setSelectedImage(file)}
          />
        </Col>
      </Row>

      <div className="mt-4">
        <Button className="btn btn-primary" onClick={handleSubmit}>
          Update Gallery
        </Button>
      </div>
    </div>
  );
};

export default UpdateGallery;
